<template>
  <div>
    <yxtf-table
      ref="radarTable"
      :data="skillsList"
      class="skill_left_table"
      row-key="skillId"
      :tree-props="{children: 'jqSkillMaps'}"
      default-expand-all
      @cell-click="handleRowClick"
    >
      <yxtf-table-column
        fixed
        :label="$t('pc_gwnl_global_lbl_skillName')"
        :show-overflow-tooltip="true"
        class-name="cursor-pointer"
        prop="name"
        width="300"
      >
        <template slot-scope="{row}">
          <span>
            {{ `${row.name}${row.jqSkillMaps && row.jqSkillMaps.length ? `(${row.jqSkillMaps.length})` : ''}` }}
          </span>
        </template>
      </yxtf-table-column>
      <yxtf-table-column
        v-for="column in columns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        class-name="color-gray-8"
      >
        <template slot-scope="{row}">
          {{ formatLevel(row,column) }}
        </template>
      </yxtf-table-column>
    </yxtf-table>
    <detail-dialog
      ref="detailDialog"
      :skill="selectSkill"
      tab-arr-key="jqSkillMaps"
      :is-result="false"
      :title="$t('pc_gwnl_web_tit_capabilityDetails')"
      :show-skill-level="skillWithLevel"
    />
  </div>
</template>

<script>
import detailDialog from './detailDialog';

export default {
  components: { detailDialog },
  props: {
    fields: { // 图例
      type: Array,
      default: () => []
    },
    skillWithLevel: Boolean,
    skillsList: { // 当前分类下的能力数据
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectSkill: {}
    };
  },
  computed: {
    noEvalPlaned() { // 未安排测评
      const fieldsName = this.fields.map(item => item.name);
      return fieldsName.findIndex(item => item !== 'excellentEavl' && item !== 'combStandardLevel') === -1;
    },
    columns() {
      return this.fields.filter(item => item.show).map(item => {
        return {
          prop: item.name,
          label: item.label,
          disabled: item.disabled
        };
      });
    }
  },
  methods: {
    handleRowClick(row, column, cell, event) {
      if (column.property !== 'name') {
        return;
      }
      this.selectSkill = row || {};
      this.$nextTick(() => {
        this.$refs.detailDialog.show();
      });
    },
    formatLevel(row, column) {
      if (row.family === 1) return '';
      return column.disabled ? '-' : this.getSkillName4show(row, ...this.getProps(column.prop));
    },
    getSkillName4show(items, levelNameProp, valueProp) {
      if (this.noEvalPlaned) {
        return items[levelNameProp] || '';
      }
      const value = items[valueProp] || 0;
      return items[levelNameProp] ? `${items[levelNameProp] || ''}（${value}）` : value;
    },
    getProps(columnName) {
      const matchedLegend = this.fields.find(
        (item) => item.name === columnName
      );
      return matchedLegend && matchedLegend.props ? [matchedLegend.props.hoverLevelProp, matchedLegend.props.hoverValueProp] : [];
    }
  }
};
</script>
<style lang="scss" scoped>
.skill_left_table {
  ::v-deep .yxtf-table th {
    color: #262626;
    background: #fbfbfd;
    border-radius: 4px 4px 0 0;
    //box-shadow: inset 0 -1px 0 0 #e9e9e9;
  }

  ::v-deep .yxtf-table__row--level-yxt-1 {
    background: #fbfbfd;
    box-shadow: inset 0 -1px 0 0 #e9e9e9;
  }

  ::v-deep .yxtf-table__row--level-yxt-0 td .cell {
    color: #262626;
    font-weight: 500;
  }
}
</style>
